/**
 * XION Medical product data — Philippine distributor (FMSInc)
 * Content sourced from xion-medical.com (split from completeProductsData.js).
 */

export const distributor = {
  shortName: 'FMSInc',
  fullName: 'Fortschritt Medical Supplies Incorporated',
  website: 'https://www.fmsmedequip.com/',
  displayUrl: 'www.fmsmedequip.com',
  statement: 'Exclusive distributor in the Philippines: Fortschritt Medical Supplies Incorporated (FMSInc) — www.fmsmedequip.com'
};
